import { useState, useEffect } from 'react'

export const useFetchFaqs = (slug) => {
  const [faqs, setFaqs] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await fetch(`/api/faqs?slug=${slug}`)
        const fetchedFaqs = await response.json()
        setFaqs(fetchedFaqs?.data?.metadata?.faqs || [])
        setLoading(false)
      } catch (err) {
        setError(err)
        setLoading(false)
      }
    }

    fetchFaqs()
  }, [])

  return { faqs, loading, error }
}
